<template>
  <div class="userManage">
    <!--搜索框-->
    <div class="topButton">
      <div class="search">
        <el-input placeholder="请输入用户名或者电话号码" v-model="searchUser" clearable>
        </el-input>
        <el-button @click="find" @keyup.native.enter="find()" type="primary">查找用户</el-button>
        <el-button @click="findAll" type="primary">查看全部</el-button>
      </div>
    </div>
    <!--数据展示-->
    <div class="mainTable1" ref="date">
      <!--表格组件-->
      <el-table ref="multipleTable" tooltip-effect="dark" border highlight-current-row  :data="tableData" :height="tableHeight" :max-height="tableHeight" :row-key="tableData.id" v-loading="loading">
        <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="240" align="center">
          <template slot-scope="scope" >
            <el-button size="mini" @click="viewUser(scope.$index, scope.row)" type="info">查看用户</el-button>
            <el-button size="mini" @click="changeUser(scope.$index, scope.row)" type="primary">修改用户</el-button>
            <el-button class="w" size="mini" @click="deleteUser(scope.$index, scope.row)" type="danger">删除用户</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页器-->
      <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.total" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChange">
      </el-pagination>
      <!-- 编辑弹框---start -->
    </div>
    <!--弹框-->
    <el-dialog  :title="formEditTitle" :visible.sync="dialogEdittVisible" width="80%" >
      <!--数据展示-->
      <el-form :label-position="labelPosition"  :disabled="formEditDisabled" :inline="true" ref="formEdit"  class="demo-form-inline" v-loading="load">
        <div class="top charFix">
          <div class="item ">
          <p><span class="red">*</span>用户名</p>
          <el-input v-model="change.username" placeholder="请输入用户名" clearable></el-input>
        </div>
          <div class="item">
            <p><span class="red">*</span>联系方式</p>
            <el-input  v-model="change.telephone" placeholder="请输入用户联系电话" clearable></el-input>
          </div>
          <div class="item">
            <p><span class="red">*</span>密码</p>
            <el-input v-model="change.password" placeholder="请输入默认密码" clearable></el-input>
          </div>
          <div class="item">
            <p>邮箱</p>
            <el-input v-model="change.email" placeholder="请输入用户邮箱" clearable></el-input>
          </div>
        </div>
        <div class="bu charFix">
          <div class="item">
          <p>用户描述</p>
          <el-input v-model="change.description" placeholder="请输入用户描述"></el-input>
        </div>
          <div class="item">
            <p><span class="red">*</span>可导出案例个数</p>
            <el-input  v-model="change.derivedNumber" placeholder="请输入用户可导出案例个数" clearable></el-input>
          </div>
          <div class="item">
            <p>性别</p>
            <el-select class="w1" v-model="change.gender" placeholder="请选择" clearable>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" ></el-option>
            </el-select>
          </div>
          <div class="item">
            <p><span class="red">*</span>用户类型</p>
            <el-select  class="w1" v-model="change.usertype" placeholder="请选择" clearable>
              <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value" ></el-option>
            </el-select>
          </div>
        </div>

        <!--按钮-->
        <div class="btnSub">
          <el-button class="w2" type="primary" @click="submitChange">确定</el-button>
          <el-button class="w2" type="info" @click="dialogEdittVisible = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--用户信息-->
    <ViewUser></ViewUser>
  </div>
</template>

<script>
  import bus from "../statistics/bus";
  import ViewUser from "./viewUser";


  export default {
    name: "用户管理",
    data(){
      return{
        loading:true,
        load:true,
        options: [
          {
            value: '1',
            label: '男'
          },
          {
            value: '2',
            label: '女'
          }
        ],
        types:[
          {
            value:'1',
            label:'超级管理员'
          },
          {
            value:'2',
            label:'数据采集员'
          },
          {
            value:'3',
            label:'普通用户'
          }
        ],
        searchUser:'',
        /*分页器的参数*/
        pageInfo: {
          currentPage: 1,
          pageSize: 10,
        },
        /*表格的最大高度*/
        tableHeight:'',
        /*表格组件渲染数组*/
        tableTitle:[
          {label:"用户ID",width:"70px",prop:"id",show:false},
          {label:"用户名",width:"150px",prop:"username",show:false},
          {label:"联系方式",width:"150px",prop:"telephone",show:true},
          {label:"邮箱",width:"200px",prop:"email",show:true},
          {label:"性别",width:"120px",prop:"gender",show:true},
          {label:"描述",width:"180px",prop:"description",show:false},
          {label:"导出个数",width:"80px",prop:"derivedNumber",show:false},
          {label:"用户类型",width:"180px",prop:"usertype",show:false},
        ],
        /*表格数据*/
        tableData: [],
        change:{
        id: '',
          username: '',
          password: '',
          telephone: '',
          email: '',
          gender: '',
          description: '',
          derivedNumber: '',
          usertype: ''
      },
        formEditTitle:'',
        formEditDisabled:false,//编辑弹窗是否可编辑
        dialogEdittVisible: false,  //编辑弹框显示
        labelPosition: '', //lable对齐方式
      }
    },
    components:{
      ViewUser,
    },
    methods:{
      /*查看用户*/
      viewUser (index,data)
      {
        bus.$emit('viewUser',index,data);
      },
      /**
       * 模糊查找用户
       */
      find(){
        this.$http.get(
          '/user/um/search/',
        {
          params:{
            searchString:this.searchUser,
            pageNo:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          }
          }
        )
          .then((response)=>{
           let data = response.data;
            const tableData = [];
            let obj = {};
            data.forEach((item,index)=>{
              tableData.push(item)
            })
            tableData.total = tableData.length;
            this.tableData = tableData;
          })
          .catch((error)=>{
            console.log(error);
          })
      },
      /**
       * 查看全部用户
       */
      findAll(){
        this.searchUser = '';
        this.pageInfo.currentPage = 1;
        let postData = {
          "pageNo": 1,
          "pageSize": 30
        };
        this.$http.get(
          '/user/um/user',
          postData
        )
          .then((response)=>{
            let data = response.data;
            let tableData = [];
            for(let i = 0;i < data.length;i++){
              let obj = [];
              obj.gender = (data[i].gender === 1)?"男":((data[i].gender === 2)?"女":"null");
              obj.usertype = (data[i].userRole.roleId == 1)?"超级管理员":((data[i].userRole.roleId == 2)?"数据采集员": "普通用户");
              for(let key of Object.keys(data[i])){
                if(key === "id" || key === "email"|| key === 'telephone' ||key === "description"||key === "derivedNumber"||key === "username" ){
                  obj[key] = data[i][key];
                }
              }
              tableData[i] = obj;
            }
            tableData.total = response.totalCount;
            this.tableData = tableData;
          })
          .catch((error)=>{
            console.log(error);
          })
      },
      /* 分页大小切换*/
      handleSizeChange(val) {
        this.pageInfo.pageSize = val;
        let postData = {
          "pageNo": this.pageInfo.currentPage,
          "pageSize": this.pageInfo.pageSize
        };
        this.$http.get(
          '/user/um/user',
          {
            params:{
              pageNo:this.pageInfo.currentPage,
              pageSize:this.pageInfo.pageSize
            }
          }
        )
          .then((response)=>{
            let tableData = [];
            let data = response.data;
            for(let i = 0;i < data.length;i++){
              let obj = [];
              obj.gender = (data[i].gender === 1)?"男":((data[i].gender === 2)?"女":"null");
              obj.usertype = (data[i].userRole.roleId == 1)?"超级管理员":((data[i].userRole.roleId == 2)?"数据采集员": "普通用户");
              for(let key of Object.keys(data[i])){
                if(key === "id" || key === "email"|| key === 'telephone' ||key === "description"||key === "derivedNumber"||key === "username" ){
                  obj[key] = data[i][key];
                }
              }
              tableData[i] = obj;
            }
            tableData.total = response.totalCount;
            this.tableData = tableData;
          })
          .catch((error)=>{
            console.log(error);
          })
      },
      /*分页切换*/
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val;
        let postData = {
          "pageNo": this.pageInfo.currentPage,
          "pageSize": this.pageInfo.pageSize
        };
        this.$http.get(
          '/user/um/user',
          {
            params:{
              pageNo:this.pageInfo.currentPage,
              pageSize:this.pageInfo.pageSize
            }
          }
        )
          .then((response)=>{
            let tableData = [];
            let data = response.data;
            for(let i = 0;i < data.length;i++){
              let obj = [];
              obj.gender = (data[i].gender === 1)?"男":((data[i].gender === 2)?"女":"null");
              obj.usertype = (data[i].userRole.roleId == 1)?"超级管理员":((data[i].userRole.roleId == 2)?"数据采集员": "普通用户");
              for(let key of Object.keys(data[i])){
                if(key === "id" || key === "email"|| key === 'telephone' ||key === "description"||key === "derivedNumber"||key === "username" ){
                  obj[key] = data[i][key];
                }
              }
              tableData[i] = obj;
            }
            tableData.total = response.totalCount;
            this.tableData = tableData;
          })
          .catch((error)=>{
            console.log(error);
          })
      },
      /*获取高度*/
      getHeight(){
        /*定义两个高度，初始高度和现在高度*/
        let nowH;
        /*延迟获取当前高度*/
        this.$nextTick(()=>{
          nowH = this.$refs.date.offsetHeight - 36;
        });
        let height = this.tableHeight;
        /*比对操作*/
        if(nowH !== height){
          this.tableHeight = nowH;
          this.table++;
        }
      },
      /*渲染表格数据*/
      getTable(pageNo,pageSize){

          let postData = {
            "pageNo": pageNo,
            "pageSize": pageSize
          };
          // console.log(postData);
          this.$http.get(
            '/user/um/user',
            {
              params:{
                pageNo:1,
                pageSize:10
              }
            }
          )
            .then((response)=>{
              let data = response.data
              let tableData = [];
              for(let i = 0;i < data.length;i++){
                let obj = [];
                for(let key of Object.keys(data[i])){
                  if(key === "id" || key === "email"|| key === 'telephone' ||key === "description"||key === "derivedNumber"||key === "username" ){
                    obj[key] = data[i][key];
                  }
                }
                obj.gender = (data[i].gender === 1)?"男":((data[i].gender === 2)?"女":"null");
                obj.usertype = (data[i].userRole.roleId == 1)?"超级管理员":((data[i].userRole.roleId == 2)?"数据采集员": "普通用户");
                tableData[i] = obj;
              }
              tableData.total = response.totalCount;
              this.tableData = tableData;
              this.$nextTick(
                this.loading = false,
              );
            })
            .catch((error)=>{
              console.log(error);
            })
      },
      /**
       * 删除对应用户
       */
      deleteUser(index,rowData){
        let postData = rowData.id;
        // console.log(postData);
        this.$http.delete(
          '/user/um/user/' + postData
        )
          .then((response)=>{
            // console.log(response);
            this.$message({
              message: "删除成功",
              type: 'success',
              center: true,
              duration:1500
            });
            this.$delete(this.tableData,index);
          })
      },
      /**
       * 修改用户信息
       */
      changeUser(index,rowData){
        for(let key of Object.keys(rowData)){
          if(key === "id" || key === "email"|| key === "gender"|| key === "usertype"|| key === 'telephone' ||key === "description"||key === "derivedNumber"||key === "username" ){
            this.change[key] = rowData[key];
          }
        }
        this.dialogEdittVisible = true;
        this.$nextTick(()=>{
          this.dialogType='show';
          this.formEditTitle='修改用户信息';
          this.formEditDisabled=false;
          this.load = false;
        });
        // console.log(this.change);
      },
      /**
       * 提交修改信息
       */
      submitChange(){
        let {id,derivedNumber,description,email,telephone,username,password} = this.change;
        let gender = (this.change.gender === '男')?1:((this.change.gender === '女')?2:this.change.gender);;
        let type = (this.change.usertype === '超级管理员')?1:((this.change.usertype === '数据采集员')?2: (this.change.usertype === '普通用户')?3:this.change.usertype);
        let formData = new FormData;
        formData.append('id',id);
        formData.append('gender',gender);
        formData.append('derivedNumber',derivedNumber);
        formData.append('description',description);
        formData.append('email',email);
        formData.append('telephone',telephone);
        formData.append('username',username);
        formData.append('type',type);
        if(password !== ''){
          formData.append('password',password);
        }
        let postData = {};
        formData.forEach((value,key)=>postData[key] = value);
        // console.log(postData);
        this.$http.put(
          '/user/um/user',
          postData
        )
          .then((response)=>{
            // console.log(response);
            this.$message(
              { message: "修改成功",
                type: 'success',
                center: true,
                duration:1500
              })

          })
          .catch((error)=>{
            // console.log(error);
            this.$message(
              { message: "修改失败",
                type: 'error',
                center: true,
                duration:1500
              })
          });
        this.dialogEdittVisible = false;
        this.change.password = '';
      }
    },
    mounted(){
      /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
      /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
      this.$nextTick(()=>{
        this.tableHeight = this.$refs.date.offsetHeight - 36;
      });
    },
    created(){
      /*在页面初始化时调用获取实时高度函数*/
      this.getHeight();
      this.getTable(1,10);
    }
  }
</script>

<style scoped>
  /*搜索框样式*/
  .userManage{
    width: 100%;
    height: calc(100% - 34px);
  }
  .userManage .topButton{
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    background-color: #E9EBEE;
  }
  .userManage .search{
    width: 30%;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .userManage .search .el-input{
    width: 60%;
  }
  .userManage .search .el-button{
    height: 40px;
    margin-left: 10px;
  }
  /*展示框样式*/
  .userManage .mainTable1{
    width: 100%;
    height: calc(100% - 50px);
  }
  .userManage .el-pagination{
    text-align: center;
  }
  /*重置默认设置*/
  .w{
    margin-left:0px !important;
  }
  .userManage .cell>.el-button{
    padding: 7px 5px;
  }
  /*弹框样式*/
  .userManage .item{
    width: 22%;
    float: left;
    margin: 20px 5px;
  }
  .top>.item{
    margin: 0px 5px;
  }
  /*清除浮动*/
  .charFix:after{
    content: "";
    display: block;
    clear: both;
  }
  .charFix{
    zoom: 1;
  }
  /*对性别选择框进行定宽*/
  .w1{
    width: 100%;
  }
  /*按钮居中*/
  .btnSub{
    text-align: center;
  }
  /*下边距处理*/
  .item>p{
    margin-bottom: 2%;
  }
  .top,.bu{
    margin-left:5% ;
  }
  /*重置样式*/
  .el-dialog__body {
    padding: 30px 20px ;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/user/userManage.vue